<template>
	<div data-spy="scroll" data-target="#navbar" data-offset="20">
		<!--Navbar Start-->
		<nav class="navbar navbar-expand-lg fixed-top" id="navbar">
			<div class="container">
				<!-- LOGO -->
				<a href="/" class="navbar-brand logo">
					<img src="/images/logo-dark.png" alt="" class="logo-dark" height="28" />
					<img src="/images/logo-light.png" alt="" class="logo-light" height="28" />
				</a>
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
						<line x1="3" y1="12" x2="21" y2="12"></line>
						<line x1="3" y1="6" x2="21" y2="6"></line>
						<line x1="3" y1="18" x2="21" y2="18"></line>
					</svg>
				</button>
				<div class="collapse navbar-collapse" id="navbarCollapse">
					<ul class="navbar-nav ms-auto navbar-center" id="navbar-navlist">
						<li class="nav-item">
							<a href="/#home" class="nav-link active">홈</a>
						</li>
						<li class="nav-item">
							<a href="/#services" class="nav-link">서비스 안내</a>
						</li>
						<li class="nav-item">
							<router-link to="/instamaketing" class="nav-link">인스타그램 마케팅</router-link>
						</li>
						<li class="nav-item">
							<a href="https://cafe.naver.com/oliviewlabs" target="_blank" class="nav-link">커뮤니티</a>
						</li>
						<li class="nav-item">
							<a href="https://www.youtube.com/channel/UCj9D_sc0KWEAGMDK3LIkv1A" target="_blank" class="nav-link">유튜브</a>
						</li>
						<li class="nav-item">
							<a href="/#pricing" class="nav-link">가격정책</a>
						</li>
					</ul>
					<a v-bind:href="link" id="btn-my" class="btn btn-sm rounded-pill nav-btn ms-lg-3">{{ linkText }}</a>
				</div>
			</div>
			<!-- end container -->
		</nav>
		<!-- Navbar End -->
		<section class="hero-1 bg-center bg-primary position-relative" style="padding: 69px 0 0 0;background-image: url(images/hero-1-bg.png);" id="home"></section>

		<!-- Services start -->
		<section class="section" id="instamarketing" style="padding-top: 30px;">
			<div class="container">
				<div class="row justify-content-center mb-1">
					<div class="col-lg-12 text-center">
						<h2 class="fw-bold">인스타그램 마케팅</h2>
					</div>
					<div class="col-lg-12 text-center">
						<iframe
							class="mt-2 youtube-iframe"
							src="https://www.youtube.com/embed/45r1J6XcZbs"
							title="YouTube video player"
							frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowfullscreen
						></iframe>
						<img src="/images/insta/006.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/007.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/001.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/002.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/003.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/004.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/005.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/008.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/insta/009.png" class="img-fluid mt-2" alt="Responsive image" />
						<img src="/images/kmongreview.png" class="img-fluid mt-2" alt="Responsive image" style="width: 860px;" />
						<img src="/images/kmongreview1.png" class="img-fluid mt-2" alt="Responsive image" style="width: 860px;" />
						<img src="/images/kmongreview2.png" class="img-fluid mt-2" alt="Responsive image" style="width: 860px;" />
						<img src="/images/kmongreview3.png" class="img-fluid mt-2" alt="Responsive image" style="width: 860px;" />
					</div>
					<div class="col-lg-1 text-center mt-3"></div>
					<div class="col-lg-5 text-center mt-3">
						<a href="https://kmong.com/gig/391232" target="_blank" class="btn btn-lg rounded-pill" style="background-color: #FCE137;width: 350px; ">크몽 최근리뷰</a>
					</div>
					<div class="col-lg-5 text-center mt-3">
						<a href="https://cafe.naver.com/oliviewlabs?iframe_url=/ArticleList.nhn%3Fsearch.clubid=30008802%26search.menuid=79%26search.boardtype=L" target="_blank" class="btn btn-lg rounded-pill" style="background-color: #3DD063;width: 350px; "
							>네이버카페 최근리뷰</a
						>
					</div>
					<div class="col-lg-1 text-center mt-3"></div>
					<div class="col-lg-1 text-center mt-3"></div>
					<div class="col-lg-5 text-center mt-3">
						<a href="https://blog.naver.com/thanks2share/222993203859" target="_blank" class="btn btn-outline-primary btn-lg rounded-pill" style="width: 350px;">더 알아보기</a>
					</div>
					<div class="col-lg-5 text-center mt-3">
						<a href="/main/insta" class="btn btn-outline-primary btn-lg rounded-pill" style="width: 350px;">가입 후 신청하기</a>
					</div>
					<div class="col-lg-1 text-center mt-3"></div>
					<div class="alert alert-primary mt-3 text-center" style="width: 860px;" role="alert">
						우측하단 네이버톡톡 또는 채널톡으로 언제든지 상담 가능합니다.
					</div>
				</div>
				<div></div>
				<div class="d-flex align-items-center"></div>
			</div>
			<!-- end container -->
		</section>
		<!-- Services end -->

		<!-- Footer Start -->
		<footer class="footer" style="background-image: url(images/footer-bg.png);">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="mb-4">
							<a href="/"><img src="/images/logo-light.png" alt="" class="" height="30"/></a>
						</div>
					</div>
					<!-- end col -->

					<div class="col-lg-12 ms-lg-auto">
						<div class="row">
							<div class="col-12">
								<div class="mt-4 mt-lg-0">
									<ul class="list-unstyled footer-sub-menu">
										<li><a href="javascript: void(0);" class="footer-link">상호명 : 마이파랑</a></li>
										<li><a href="javascript: void(0);" class="footer-link">대표 : 오한식</a></li>
										<li><a href="javascript: void(0);" class="footer-link">이메일 : myparang.io@gmail.com</a></li>
										<li><a href="javascript: void(0);" class="footer-link">사업장소재지 : 경기 안양시 동안구 엘에스로 142 B102호</a></li>
										<li><a href="javascript: void(0);" class="footer-link">통신판매업신고 : 제 2022-안양동안-0130 호</a></li>
										<li><a href="javascript: void(0);" class="footer-link">사업자등록번호 : 599-35-00633</a></li>
										<li><a href="javascript: void(0);" class="footer-link">Copyright(c) 2019 - 2023 MyParang. All rights reserved</a></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<!-- end col -->
				</div>
				<!-- end row -->

				<div class="row">
					<div class="col-lg-12">
						<div class="text-center mt-5">
							<p class="text-white-50 f-15 mb-0"></p>
						</div>
					</div>
					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</footer>
		<!-- Footer End -->
	</div>
</template>

<script>
export default {
	data() {
		return {
			link: "/signin",
			linkText: "로그인",
			youtubesrc: "https://www.youtube.com/embed/T2IQ1OqidEs"
		};
	},
	beforeMount() {
		this.checkSignin();
	},
	methods: {
		checkSignin: function(e) {
			var loginCookie = this.$cookies.get("MID");
			if (loginCookie != undefined && loginCookie != "0") {
				this.link = "/user/myinfo";
				this.linkText = "내정보";
			} else {
				this.link = "/signin";
				this.linkText = "로그인";
			}
		}
	}
};
</script>
<style>
.youtube-iframe {
	position: relative;
	max-width: 860px;
	width: 100%;
	height: 480px;
}
</style>



// WEBPACK FOOTER //
// src/components/event/InstaMarketing.vue